"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminPaymentInfoBlock = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
require("./admin-payment-info-block.scss");
const AdminPaymentInfoBlock = (props) => {
    const { className, children, title = '', modifier } = props;
    const classNames = (0, classnames_1.default)('admin-payment-info-block', className !== null && className !== void 0 ? className : '', modifier && `admin-payment-info-block--${modifier}`);
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("h3", { className: 'admin-payment-info-block__title' }, title),
        react_1.default.createElement("div", { className: 'admin-payment-info-block__content' }, children)));
};
exports.AdminPaymentInfoBlock = AdminPaymentInfoBlock;
//# sourceMappingURL=AdminPaymentInfoBlock.js.map